import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }

import useVuelidate from '@vuelidate/core';
import { required, url } from '@vuelidate/validators';
import { ArticleAppConfig } from './models/ArticleApp';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentHighlightsArticleAppEdit',
  props: {
  modelValue: {
    type: Object as PropType<ArticleAppConfig>,
    required: true,
  },
},
  emits: ["update:modelValue", "isInvalid"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const value = useVModel(props, 'modelValue', emit);

const validations = {
  image_url: { required, url },
  header_text: { required },
  body_text: { required },
  article_url: { required, url },
  link_label: { required },
};

const $v = useVuelidate(validations, value);

function markAsTouched(key: string & keyof ArticleAppConfig) {
  const field = $v.value[key];
  if (field) {
    field.$touch();
  }
  emit('isInvalid', $v.value.$invalid);
}

function getErrorMessage(fieldName: string & keyof ArticleAppConfig, label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, fieldName, label);
}

return (_ctx: any,_cache: any) => {
  const _component_n_text_input = _resolveComponent("n-text-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).image_url,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(value).image_url) = $event)),
        label: "Image URL",
        errorMessage: getErrorMessage('image_url', 'Image URL'),
        onInput: _cache[1] || (_cache[1] = () => markAsTouched('image_url'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).header_text,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(value).header_text) = $event)),
        label: "Header Text",
        errorMessage: getErrorMessage('header_text', 'Header Text'),
        onInput: _cache[3] || (_cache[3] = () => markAsTouched('header_text'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).body_text,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(value).body_text) = $event)),
        label: "Body Text",
        errorMessage: getErrorMessage('body_text', 'Body Text'),
        onInput: _cache[5] || (_cache[5] = () => markAsTouched('body_text'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).article_url,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(value).article_url) = $event)),
        label: "Article URL",
        errorMessage: getErrorMessage('article_url', 'Article URL'),
        onInput: _cache[7] || (_cache[7] = () => markAsTouched('article_url'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).link_label,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(value).link_label) = $event)),
        label: "Link Label",
        errorMessage: getErrorMessage('link_label', 'Link Label'),
        onInput: _cache[9] || (_cache[9] = () => markAsTouched('link_label'))
      }, null, 8, ["modelValue", "errorMessage"])
    ])
  ]))
}
}

})